import React, { Component } from 'react';
import classNames from 'classnames';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import Popover from 'material-ui/Popover';
import MenuDropdownButton from './menuDropdownButton';
import styles from './style.scss';

export default class MenuDropdown extends Component {

    state = {
        openContextMenu: false,
        selectedItemText: 'select'
    };
    
    buildDropdownList = () => {

        if(this.props.data 
            && this.props.data.length > 0) {

                if (this.props.value > 0) {
                    
                    const results = this.props.data.filter(a => a.id === this.props.value);

                    if (results.length > 0) {
                    
                        this.setState({
                            selectedItemText: results[0].name
                        });
                    }
                }
                else {

                    this.setState({
                        selectedItemText: this.props.data[0].name
                    });
                }
        }
    }

    componentDidMount() {

        this.buildDropdownList();
    }

    open = (event) => {

        event.preventDefault();
    
        this.setState({
            openContextMenu: true,
            anchorEl: event.currentTarget
        });
    }

    select = (et, menuItem, index) => {

        this.setState({
            selectedItemText: menuItem.props.primaryText
        });

        this.closeContextMenu();

        this.props.onItemClick(menuItem);
    }

    closeContextMenu = () => {
        
        this.setState({
            openContextMenu: false
        });
    }
    
    render() {
        
        const { data } = this.props;

        const selectedMenuItemStyle = {
            backgroundColor: '#EDEFF5',
            color: '#4A90E2'
        };

        return (
            <div>
                <MenuDropdownButton
                    onClick={this.open}
                    selectedItemText={this.state.selectedItemText} 
                />
                <Popover
                    className='edit-context-menu menu-dropdown'
                    className={classNames(styles.editContextMenu,
                                            styles.menuDropdown)}
                    style={{
                        fontSize: '15px'
                    }}
                    open={this.state.openContextMenu}
                    anchorEl={this.state.anchorEl}
                    targetOrigin={{horizontal: 'middle', vertical: 'top'}}
                    anchorOrigin={{horizontal: 'middle', vertical: 'bottom'}}
                    onRequestClose={this.closeContextMenu}
                >
                    <Menu
                        onItemClick={this.select}
                        value={this.props.value}
                        selectedMenuItemStyle={selectedMenuItemStyle}
                    >
                        {
                            data.map((p, index) => {
                                
                                return (<MenuItem
                                            key={p.id} 
                                            value={p.id}
                                            primaryText={<span title={p.name}>{p.name}</span>}
                                            innerDivStyle={{
                                                fontSize: '15px',
                                                width: '150px',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis'
                                            }}
                                        />)
                            })
                        }
                    </Menu>
                </Popover>
            </div>
        );
    }
}